// pages/product/[id]/[slug].tsx
import type { GetServerSideProps } from "next";
import { slugify } from "utils/slug";
import productService from "services/product";
import ProductContainer from "containers/productContainer/productContainer";
import ProductList from "components/productList/productList";
import ProductReview from "components/productReview/productReview";
import SEO from "components/seo";

// Tip rilassato: evitiamo mismatch con i tipi interni del progetto
type ProductPageProps = { product: any };

export default function ProductPage({ product }: ProductPageProps) {
  if (!product) return null;

  return (
    <>
      <SEO
        title={product?.translation?.title}
        description={product?.translation?.description}
        image={product?.img}
      />

      <main className="container">
        <div style={{ maxWidth: "1052px", margin: "0 auto" }}>
          <ProductContainer
            key={product?.id}
            data={product as any}
            loading={false}
          />

          <ProductList
            title="related.products"
            params={{
              category_id: product?.category_id,
              brand_id: product?.brand_id,
              product_id: product?.id,   // ⬅️ MINIMA MODIFICA
            }}
            enabled={!!product?.id}
          />

          <ProductReview
            productId={product?.id}
            productUuid={product?.uuid}
            shop={product?.shop}
          />
        </div>
      </main>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  try {
    const idParam = ctx.params?.id;
    const slugParam = ctx.params?.slug;

    if (!idParam || Array.isArray(idParam) || !slugParam || Array.isArray(slugParam)) {
      return { notFound: true };
    }

    const lang = (ctx.locale as string) || "it";
    const numId = Number(idParam);
    if (Number.isNaN(numId)) return { notFound: true };

    // ✅ Prendiamo il prodotto SEMPRE per ID numerico
    const byId = await productService.getByIdNumber(numId, { lang }).catch(() => null);
    const product: any = (byId as any)?.data ?? null;
    if (!product) return { notFound: true };

    // ✅ Slug canonico derivato DAL TITOLO (niente “-1”)
    const title = product?.translation?.title || "";
    const canonicalSlug = slugify(title);

    // ❌ Nessun redirect automatico: se lo slug non coincide, 404
    if (slugParam !== canonicalSlug) {
      return { notFound: true };
    }

    return { props: { product } };
  } catch {
    return { notFound: true };
  }
};
